import { conversionEventWithUserData } from './conversionEventWithUserData';
import { isDDMShowroom } from './isDDMShowroom';

/**
 * Essa função roda sempre que uma conversão for enviada com sucesso,
 *
 * @param {object} Dados da conversão enviados para a API
 */
export default function autoHookConversion(conversion) {
  const eventName = 'conversion';

  const gtmEvent = isDDMShowroom()
    ? conversionEventWithUserData(eventName, conversion)
    : { event: eventName };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(gtmEvent);

  const hasItemConversionData = window.itemConversionData !== undefined;

  if (isDDMShowroom() && hasItemConversionData) {
    window.DDMDataLayerService.addItemConversionEvent();
  }
}
